import {configureStore} from '@reduxjs/toolkit';
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';

import {preloadedState} from './constants';
import reducer from './reducers';
import success from './success';
import * as successDataAsyncActions from './success/actions';
import * as successSelectors from './success/selectors';
import survey from './survey';
import * as surveyDataAsyncActions from './survey/actions';
import * as surveySelectors from './survey/selectors';
import system from './system';
import * as systemDataAsyncActions from './system/actions';
import * as systemSelectors from './system/selectors';

const actions = {
    ...survey.actions,
    ...surveyDataAsyncActions,
    ...success.actions,
    ...successDataAsyncActions,
    ...system.actions,
    ...systemDataAsyncActions,
};

const selectors = {
    ...surveySelectors,
    ...successSelectors,
    ...systemSelectors,
};

export const store = configureStore({
    reducer,
    preloadedState,
    devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;

export {selectors, actions};
